import type {AddComponentTypeOptions} from 'grapesjs';
import {asteriskHtml, createBaseBoxComponent} from '@FormMakerReact/components/create-base-box-component';
import {POSTERMYWALL_FORM_SPACER_TYPE} from '@FormMakerReact/components/postermywall-form-spacer/postermywall-form-spacer';
import {POSTERMYWALL_FORM_TEXT_TYPE} from '@FormMakerReact/components/postermywall-form-text/postermywall-form-text';
import {buildCustomInputType} from '@FormMakerReact/components/postermywall-custom-input/postermywall-custom-input';

export const POSTERMYWALL_CUSTOM_BOX_TYPE_PREFIX = 'postermywall-custom-box';

export const buildCustomBoxType = (index: number): string => `${POSTERMYWALL_CUSTOM_BOX_TYPE_PREFIX}-${index}`;

export function buildCustomBoxComponent(index: number, defaultLabel = 'Custom field'): AddComponentTypeOptions {
  return createBaseBoxComponent({
    boxType: buildCustomBoxType(index),
    dataMarkerAttribute: `data-is-pmw-form-custom-${index}-box`,
    components: [
      {type: POSTERMYWALL_FORM_SPACER_TYPE},
      {
        type: POSTERMYWALL_FORM_TEXT_TYPE,
        content: `<strong>${defaultLabel}${asteriskHtml()}</strong>`,
        editable: false,
      },
      {type: buildCustomInputType(index)},
    ],
  });
}
